import type { IconSvgObject } from './types';

const LocationUser03Icon: IconSvgObject = [
  ["path", { d: "M5 16.5C4.36284 17.0288 4 17.6682 4 18.3158C4 20.3505 7.58172 22 12 22C16.4183 22 20 20.3505 20 18.3158C20 17.6682 19.6372 17.0288 19 16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 14H9L10.5 19H13.5L15 14H17V12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12V14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "4.5", r: "2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LocationUser03Icon;
